import { CartLinesUpdateEvent } from '@shopify/events';
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.ll6-buy-form, .lbt005__form')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button.disabled) return;
  const message = form.querySelector('.ll6-form-message');
  const label = button.querySelector('[data-ll6-label]') || button;
  const original = label.textContent;
  const card=form.closest('.ll6-card');
  if(card){document.querySelectorAll('[data-lbt005-trust-set]').forEach(el=>el.textContent=card.querySelector('h3').textContent+' — '+card.querySelector('.ll6-card__contents').textContent);document.querySelectorAll('[data-lbt005-trust-price]').forEach(el=>el.textContent=card.querySelector('.ll6-card__price').textContent);}
  button.disabled = true;
  button.setAttribute('aria-busy','true');
  label.textContent = document.documentElement.lang === 'en' ? 'Adding…' : original;
  if(message) message.hidden = true;
  const data = new FormData(form);
  const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))];
  data.set('sections',sectionIds.join(','));
  data.set('sections_url',location.pathname + location.search);
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(data.get('id')),quantity:Number(data.get('quantity'))||1}],promise:deferred.promise}));
  try {
    const response = await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'),{method:'POST',headers:{Accept:'application/json'},body:data});
    const result=await response.json();
    if(!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this set. Please try again.');
    const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'lintlume-offers',sourceId:form.id,itemCount:Number(data.get('quantity'))||1,sections:result.sections,didError:false}});
    const drawer=document.querySelector('#cart-drawer');
    if(drawer){await customElements.whenDefined('theme-drawer');requestAnimationFrame(()=>drawer.open());}else{location.assign(window.Shopify.routes.root+'cart');}
  } catch(error) {
    deferred.resolve({detail:{didError:true}});
    if(message){message.textContent=error.message;message.hidden=false;}
  } finally {button.disabled=false;button.removeAttribute('aria-busy');label.textContent=original;}
});
document.addEventListener('click',event=>{const button=event.target.closest('[data-ll6-price]');if(!button)return;document.querySelectorAll('[data-lbt005-trust-set]').forEach(el=>el.textContent=button.dataset.ll6Title);document.querySelectorAll('[data-lbt005-trust-price]').forEach(el=>el.textContent=button.dataset.ll6Price);});

